import { ReactNode, useState } from "react";
import FlagQuestionModal from "../../components/Modal/FlagQuestionModal";
import { Button as BootstrapButton, Button } from "react-bootstrap";
import { IoIosCheckmarkCircle } from "react-icons/io";
// import Button from "../../components/Button/Button";
import {
  BsArrowLeftCircleFill,
  BsArrowRightCircleFill,
  BsFlag,
  BsStar,
  BsStarFill,
} from "react-icons/bs";
import { Question } from "../../types";

export const AssignmentPageTitle = (props: {
  questionNumber: number;
  question: Question;
  totalQuestions: number;
  isAssignmentMode: boolean;
  submitAssignment?: () => void;
  onNextQuestionClicked?: () => void;
  nextQuestionButtonDisabled?: boolean;
  onPreviousQuestionClicked?: () => void;
  prevQuestionButtonDisabled?: boolean;
  currentQuestionIndex?: number;
  // onSkipQuestionClicked?: () => void;
  handleStarQuestion?: () => void;
  leftExtra?: ReactNode;
  rightExtra?: ReactNode;
  isStarred?: boolean;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleShowModal = () => setShowModal(true);
  return (
    <>
      <div
        style={{
          display: "flex",
        }}
      >
        <h4
          style={{
            margin: "auto",
            marginRight: "15px",
          }}
        >
          Question {props.questionNumber} of {props.totalQuestions}
        </h4>

        {props.handleStarQuestion && (
          <button
            onClick={props.handleStarQuestion}
            style={{
              display: "flex",
              borderRadius: "3px",
              marginLeft: "5px",
              backgroundColor: "transparent",
            }}
          >
            {(props.isStarred ?? (props.question.starredBy.length > 0)) ? (
              <BsStarFill
                color="orange"
                style={{
                  margin: "auto",
                }}
              />
            ) : (
              <BsStar
                color="orange"
                style={{
                  margin: "auto",
                }}
              />
            )}
          </button>
        )}

        <button
          onClick={handleShowModal}
          style={{
            display: "flex",
            borderRadius: "3px",
            marginLeft: "5px",
            backgroundColor: "transparent",
          }}
        >
          <div
            style={{
              padding: "2px",
            }}
          >
            <BsFlag
              color="red"
              style={{
                margin: "auto",
              }}
            />
          </div>
        </button>
      </div>

      <div
        style={{
          display: "flex",
          gap: "1px",
        }}
      >
        {props.rightExtra ? (
          <div style={{ alignSelf: "center", marginRight: 8 }}>{props.rightExtra}</div>
        ) : null}
        {props.isAssignmentMode ? (
          <BootstrapButton
            variant="dark"
            size="sm"
            className="small"
            onClick={props.submitAssignment}
            style={
              {
                // fontSize: '0.9rem'
              }
            }
          >
            Submit Exam <IoIosCheckmarkCircle />
          </BootstrapButton>
        ) : undefined}

        {props.leftExtra ? (
          <div style={{ alignSelf: "center", marginRight: 8 }}>{props.leftExtra}</div>
        ) : null}

        <>
          <button
            style={{
              height: "fit-content",
              backgroundColor: "transparent",
            }}
            onClick={props.onPreviousQuestionClicked}
            disabled={props.prevQuestionButtonDisabled}
          >
            <div>
              <BsArrowLeftCircleFill
                size={22}
                style={{
                  margin: "auto 5px auto auto",
                }}
                color={props.prevQuestionButtonDisabled ? "grey" : "#0d6efd"}
              />
            </div>
          </button>

          <button
            style={{
              height: "fit-content",
              backgroundColor: "transparent",
            }}
            onClick={props.onNextQuestionClicked}
            disabled={props.nextQuestionButtonDisabled}
          >
            <div>
              <BsArrowRightCircleFill
                size={22}
                style={{
                  margin: "auto auto auto 5px",
                }}
                color={props.nextQuestionButtonDisabled ? "grey" : "#0d6efd"}
              />
            </div>
          </button>
        </>
      </div>

      {/* <Button text="Skip question" type="inverse" /> */}
      <FlagQuestionModal
        setShowModal={setShowModal}
        showModal={showModal}
        questionId={props.question.id}
      ></FlagQuestionModal>
    </>
  );
};
